
<template>
<div class="row">
    <!-- <h4>Boletos</h4> -->
    <!-- <div class="col-md-12 text-right">
        <b-button variant="primary" size="sm" class="mb-2" @click="showModalBoletosUpload"><i class="fa fa-upload"></i> Enviar Arquivo</b-button>
    </div> -->

    <!------------------------------------------------------ Modal File Upload ----------------------------- -->
    <b-modal title="Importar Arquivo de boletos" v-model="openedModal">
        <b-card>
            <b-card-body>
                <div class="row">
                    <div class="col-md-12" v-if="!boletosImportados">
                        <div class="form-group">
                            <label for="">Escolha o Arquivo</label>
                            <input type="file" class="form-control" @change='changeFile'>
                        </div>
                        <div class="col-md-12 text-center">
                            <button class="btn btn-success" @click.prevent="sendFileBoletos"><i class="fa fa-send"></i> Enviar</button>
                        </div>
                    </div>
                    <div class="col-md-12" v-if="boletosImportados">

                        <p>
                            <strong>Adição de Boletos Abertos: </strong> {{abertos.length}}
                        </p>

                        <p>
                            <strong>Boletos para baixa: </strong> {{baixas.length}}
                        </p>
                        <p>
                            <strong>Boletos não disponíveis para baixa: </strong> {{noBaixa.length}}
                        </p>
                        <p>
                            <strong>Boletos Duplicado: </strong> {{noAdd.length}}
                        </p>
                        <p>
                            <strong>Distribuidor Não Encontrado: </strong> {{ erroDistribuidor.length}}
                        </p>
                        <p>
                            <strong>Empresa Não Encontrada: </strong> {{ erroEmpresa.length}}
                        </p>
                        <p>
                            <strong>Banco não Habilitado para adição/baixa de Boleto: </strong> {{erroBanco.length}}
                        </p>

                        <p>
                            <strong>Erro Diversos: </strong> {{erroDesconhecido.length}}
                        </p>
                    </div>
                </div>
            </b-card-body>            
        </b-card>
		<template #modal-footer>
                <b-button variant="danger" size="sm" v-if="boletosImportados" @click='addImportados'><i class="fa fa-save"></i> Confirmar Operação</b-button>
                <b-button variant="danger" size="sm" @click="openedModal = false">Cancelar</b-button>
		</template>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {

        return {
            fileBoletos: null,
            boletosImportados: false,
            abertos: [],
            baixas: [],
            erroDistribuidor: [],
            erroEmpresa: [],
            erroBanco: [],
            erroDesconhecido: [],
            noBaixa: [],
            noAdd: [],
            openedModal: false

        }
    },
    methods: {

        changeFile(e) {
            this.fileBoletos = null;
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            if (!this.validateExtension(files[0])) {

                return;
            }

            this.fileBoletos = files[0];
        },
        showModalBoletosUpload() {
            this.boletosImportados = false;
            this.openedModal = true;
        },
        sendFileBoletos() {
            if (this.fileBoletos === null) {
                alert('Anexe um arquivo válido');
                return;
            } else if (!this.validateExtension(this.fileBoletos)) {
                return;
            }
            var form = new FormData();

            form.append('boletos', this.fileBoletos);
            var vm = this;
            $('.loading').show();
            axios.post('/adm/boletos/interpreter', form).then(function (response) {
                var data = response.data;
                console.log(data);
                vm.boletosImportados = true;
                vm.abertos = data.abertos;
                vm.baixas = data.baixas;
                vm.erroDistribuidor = data.erro_distribuidor;
                vm.erroEmpresa = data.erro_empresa;
                vm.erroBanco = data.erro_banco;
                vm.erroDesconhecido = data.erro_desconhecido;
                vm.noBaixa = data.no_baixa;
                vm.noAdd = data.no_add;

                $('.loading').hide();
            }).catch(function (error) {
                alert(error.response.data.errors.join(','));
                console.log(error);
                $('.loading').hide();

            });
        },

        validateExtension(file) {
            if (!file.name.match(/\.(csv|txt)$/i)) {
                alert('Anexe um arquivo CSV ou TXT');
                return false;
            }
            return true;
        },
        addImportados() {
            if (this.baixas.length === 0 && this.abertos.length === 0) {
                alert("Não há dados para serem gravados");
                return;
            }
            $('.loading').show();
            var vm = this;
            axios.post('/adm/boletos', {
                abertos: this.abertos,
                baixas: this.baixas
            }).then(function (response) {
                vm.openedModal = false;
                $('.loading').hide();
            }).catch(function (error) {
                alert(error.response.data.errors.join(','));
                console.log(error);
                $('.loading').hide();

            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_boleto/Main.vue